import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import iconFileCircle1 from "../img/icons/icon-file-circle-1.svg";
import iconFileCircle2 from "../img/icons/icon-file-circle-2.svg";
import iconFileCircle3 from "../img/icons/icon-file-circle-3.svg";
import toast, {Toaster} from "react-hot-toast";
import MemberSidebar from "../inc/MemberSidebar";
export default function Proposal(prop) {
    let navigate = useNavigate();

    let member = prop.member;
    let [listing, setListing] = React.useState(null);
    let [countDraft, setCountDraft] = React.useState(0);
    let [countOffer, setCountOffer] = React.useState(0);
    let [statusList, setStatusList] = React.useState(null);

    let [listingByTeam, setListingByTeam] = React.useState(null);
    let [countTeam, setCountTeam] = React.useState(0);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        (async function() {
            try {
                const resultStatus = await Utils.getProposalStatus();
                setStatusList(resultStatus);

                const result = await getListing();
                setListing(result);

                const resultTeam = await getListingByTeam(member.idcard);
                if(resultTeam) {
                    setCountTeam(resultTeam.count);
                    setListingByTeam(resultTeam);
                }

                if(result) {
                    let statusDraft = 0;
                    let statusOffer = 0;
                    for(let rs of result.rows) {
                        if(rs.status === Utils.PROPOSAL_STATUS_DRAFT) {
                            statusDraft++;
                        }
                        else if(rs.status === Utils.PROPOSAL_STATUS_OFFER
                            || rs.status === Utils.PROPOSAL_STATUS_ACCEPT
                            || rs.status === Utils.PROPOSAL_STATUS_EDIT
                            || rs.status === Utils.PROPOSAL_STATUS_UPDATE
                            || rs.status === Utils.PROPOSAL_STATUS_REJECT
                        ) {
                            statusOffer++;
                        }
                    }
                    setCountDraft(statusDraft);
                    setCountOffer(statusOffer);
                }

                document.title = 'ข้อเสนอโครงการ | NCSA';
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getListingByTeam(idcard) {
        const response = await fetch(Config.apiUrl +'/proposal/listByTeam', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                idcard: idcard
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getListing() {
        const response = await fetch(Config.apiUrl +'/proposal/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                memberId: member.id,
                status: [
                    Utils.PROPOSAL_STATUS_DRAFT,
                    Utils.PROPOSAL_STATUS_OFFER,
                    Utils.PROPOSAL_STATUS_ACCEPT,
                    Utils.PROPOSAL_STATUS_EDIT,
                    Utils.PROPOSAL_STATUS_UPDATE,
                    Utils.PROPOSAL_STATUS_REJECT
                ]
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="proposal" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3 mb-3">{prop.lang === 'en' ? 'Project Proposal':'ข้อเสนอโครงการ'}</h2>
                                <div className="row g-xxl-4 g-3">
                                    <div className="col-md-4">
                                        <div className="card-statistics">
                                            <div className="card-group">
                                                <img className="icons" src={iconFileCircle1} alt="" />
                                                <p>{prop.lang ? 'Draft':'ยังไม่ได้ยื่นข้อเสนอ'}</p>
                                            </div>
                                            <h2 className="number">{countDraft}</h2>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="card-statistics">
                                            <div className="card-group">
                                                <img className="icons" src={iconFileCircle2} alt="" />
                                                <p>{prop.lang ? 'Pending':'ยื่นข้อเสนอแล้ว'}</p>
                                            </div>
                                            <h2 className="number">{countOffer}</h2>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="card-statistics">
                                            <div className="card-group">
                                                <img className="icons" src={iconFileCircle3} alt="" />
                                                <p>{prop.lang ? 'Project Participants':'โครงการที่เป็นผู้ร่วมโครงการ'}</p>
                                            </div>
                                            <h2 className="number">{countTeam}</h2>
                                        </div>
                                    </div>
                                </div>
                                <h4 className="title-line-left mt-5 mb-3">{prop.lang === 'en' ? 'My project proposal':'ข้อเสนอโครงการของท่าน'}</h4>
                                <div className="table-responsive mt-3">
                                    <table className="table table-info table-hover text-center">
                                        <thead>
                                            <tr key={-2}>
                                                <th className="text-center" style={{width: '110px'}}>{prop.lang === 'en' ? 'Code':'รหัสโครงการ'}</th>
                                                <th className="text-start">{prop.lang === 'en' ? 'Submitted Proposal':'ข้อเสนอโครงการ'}</th>
                                                <th style={{width: '70px'}}>{prop.lang === 'en' ? 'Status':'สถานะ'}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            listing !== null && listing.count > 0 ?
                                                listing.rows.map((row, index) => {
                                                    return (<>
                                                        <tr key={index}>
                                                            <td className="text-center" style={{borderBottomWidth:[
                                                                    Utils.PROPOSAL_STATUS_ACCEPT,
                                                                    Utils.PROPOSAL_STATUS_INPROGRESS,
                                                                    Utils.PROPOSAL_STATUS_EDIT,
                                                                    Utils.PROPOSAL_STATUS_UPDATE].includes(row.status)? 0:'1px'}}>{row.code}</td>
                                                            <td className="text-start" style={{borderBottomWidth:[
                                                                    Utils.PROPOSAL_STATUS_ACCEPT,
                                                                    Utils.PROPOSAL_STATUS_INPROGRESS,
                                                                    Utils.PROPOSAL_STATUS_EDIT,
                                                                    Utils.PROPOSAL_STATUS_UPDATE].includes(row.status)? 0:'1px'}}>
                                                                <p><strong className="text-primary">{prop.lang === 'en' ? 'Proposal Name':'ชื่อโครงการ'} :</strong> {prop.lang === 'en' ? row.title_en:row.title}</p>
                                                                <p><strong className="text-primary">{prop.lang === 'en' ? 'Scholarship':'ชื่อทุน'} :</strong> {prop.lang === 'en' ? row.scholarship.title_en : row.scholarship.title}</p>
                                                                <p><strong className="text-primary">{prop.lang === 'en' ? 'Date':'วันที่สร้างข้อเสนอโครงการ'} :</strong> {Utils.dateTimeText(row.createdAt)}</p>
                                                            </td>
                                                            <td style={{borderBottomWidth:[
                                                                    Utils.PROPOSAL_STATUS_ACCEPT,
                                                                    Utils.PROPOSAL_STATUS_INPROGRESS,
                                                                    Utils.PROPOSAL_STATUS_EDIT,
                                                                    Utils.PROPOSAL_STATUS_UPDATE].includes(row.status)? 0:'1px'}}><span className={"badge " + (Utils.proposalStatusColor(row.status))}>{statusList.filter(e => e.id === row.status)[0].title}</span></td>
                                                        </tr>
                                                            {
                                                                [Utils.PROPOSAL_STATUS_DRAFT,
                                                                Utils.PROPOSAL_STATUS_EDIT].includes(row.status) ?
                                                                <tr>
                                                                    <td colSpan={4}>
                                                                        <NavLink className="btn btn-xs btn-gray" to={(prop.lang === 'en' ? '/en':'') + '/proposal/applicant/' + Utils.encodeItem({proposalId: row.id})}>
                                                                            {prop.lang === 'en' ? 'Scholarship Applicants':'ผู้ขอรับทุน'}
                                                                        </NavLink>
                                                                        <NavLink className="btn btn-xs btn-gray mt-1" to={(prop.lang === 'en' ? '/en':'') + '/proposal/part1/' + Utils.encodeItem({proposalId: row.id})}>
                                                                            {prop.lang === 'en' ? 'Part 1 General':'ส่วนที่ 1 ข้อมูลทั่วไป'}
                                                                        </NavLink>
                                                                        <NavLink className="btn btn-xs btn-gray mt-1" to={(prop.lang === 'en' ? '/en':'') + '/proposal/part2/' + Utils.encodeItem({proposalId: row.id})}>
                                                                            {prop.lang === 'en' ? 'Part 2 Research project information':'ส่วนที่ 2 ข้อมูลโครงการวิจัย'}
                                                                        </NavLink>
                                                                        <NavLink className="btn btn-xs btn-gray mt-1" to={(prop.lang === 'en' ? '/en':'') + '/proposal/part3/' + Utils.encodeItem({proposalId: row.id})}>
                                                                            {prop.lang === 'en' ? 'Part 3 Plan':'ส่วนที่ 3 แผนงาน'}
                                                                        </NavLink>
                                                                        <NavLink className="btn btn-xs btn-gray mt-1" to={(prop.lang === 'en' ? '/en':'') + '/proposal/part4/' + Utils.encodeItem({proposalId: row.id})}>
                                                                            {prop.lang === 'en' ? 'Part 4 Business Operator Information (Optional)':'ส่วนที่ 4 ข้อมูลผู้ประกอบการ (ถ้ามี)'}
                                                                        </NavLink>
                                                                        <NavLink className="btn btn-xs btn-gray mt-1" to={(prop.lang === 'en' ? '/en':'') + '/proposal/part5/' + Utils.encodeItem({proposalId: row.id})}>
                                                                            {prop.lang === 'en' ? 'Part 5 Output/Result/Impact':'ส่วนที่ 5 ผลผลิต/ผลลัพธ์/ผลกระทบ'}
                                                                        </NavLink>
                                                                        <p className="text-center my-3 w-100">
                                                                            {
                                                                                row.status === Utils.PROPOSAL_STATUS_DRAFT ? <NavLink className="btn btn-xs btn-green m-auto w-130" to={(prop.lang === 'en' ? '/en':'') + '/proposal/confirm/' + Utils.encodeItem({proposalId: row.id})}>
                                                                                    {prop.lang === 'en' ? 'Send Offer':'ส่งพิจารณา'}
                                                                                </NavLink> : ''
                                                                            }
                                                                            {
                                                                                row.status === Utils.PROPOSAL_STATUS_EDIT ? <NavLink className="btn btn-xs btn-green m-auto w-130" to={(prop.lang === 'en' ? '/en':'') + '/proposal/edit/' + Utils.encodeItem({proposalId: row.id})}>
                                                                                    {prop.lang === 'en' ? 'Send Update':'ส่งอัพเดต(แก้ไข)'}
                                                                                </NavLink> : ''
                                                                            }
                                                                        </p>
                                                                    </td>
                                                                </tr> : ''
                                                            }
                                                        </>
                                                    )
                                                }) : <tr key={-1}><td colSpan={4} className="text-center">{prop.lang === 'en' ? 'No projects submitted':'ยังไม่มีโครงการที่ยื่นเสนอ'}</td></tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                                <h4 className="title-line-left mt-5 mb-3">{prop.lang === 'en' ? 'Project Participants':'ข้อเสนอโครงการที่เป็นผู้ร่วมโครงการ'}</h4>
                                <div className="table-responsive mt-3">
                                    <table className="table table-info table-hover text-center">
                                        <thead>
                                        <tr key={-2}>
                                            <th className="text-center" style={{width: '110px'}}>{prop.lang === 'en' ? 'Code':'รหัสโครงการ'}</th>
                                            <th className="text-start">{prop.lang === 'en' ? 'Submitted Proposal':'ข้อเสนอโครงการ'}</th>
                                            <th style={{width: '70px'}}>{prop.lang === 'en' ? 'Status':'สถานะ'}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            listingByTeam !== null && listingByTeam.count > 0 ?
                                                listingByTeam.rows.map((row, index) => {
                                                    return (<>
                                                            <tr key={index}>
                                                                <td className="text-center">{row.code}</td>
                                                                <td className="text-start">
                                                                    <p><strong className="text-primary">{prop.lang === 'en' ? 'Proposal Name':'ชื่อโครงการ'} :</strong> {row.title}</p>
                                                                    <p><strong className="text-primary">{prop.lang === 'en' ? 'Scholarship':'ชื่อทุน'} :</strong> {prop.lang === 'en' ? row.scholarship.title_en : row.scholarship.title}</p>
                                                                    <p><strong className="text-primary">{prop.lang === 'en' ? 'Date':'วันที่สร้างข้อเสนอโครงการ'} :</strong> {Utils.dateTimeText(row.createdAt)}</p>
                                                                </td>
                                                                <td><span className={"badge " + (Utils.proposalStatusColor(row.status))}>{statusList.filter(e => e.id === row.status)[0].title}</span></td>
                                                            </tr>
                                                            {
                                                                [Utils.PROPOSAL_STATUS_DRAFT,
                                                                    Utils.PROPOSAL_STATUS_OFFER,
                                                                    Utils.PROPOSAL_STATUS_ACCEPT,
                                                                    Utils.PROPOSAL_STATUS_INPROGRESS,
                                                                    Utils.PROPOSAL_STATUS_EDIT,
                                                                    Utils.PROPOSAL_STATUS_UPDATE].includes(row.status) ?
                                                                    <tr>
                                                                        <td colSpan={4}>
                                                                            <NavLink className="btn btn-xs btn-gray" to={(prop.lang === 'en' ? '/en':'') + '/proposal/applicant/' + Utils.encodeItem({proposalId: row.id, readOnly: true})}>
                                                                                {prop.lang === 'en' ? 'Scholarship Applicants':'ผู้ขอรับทุน'}
                                                                            </NavLink>
                                                                            <NavLink className="btn btn-xs btn-gray mt-1" to={(prop.lang === 'en' ? '/en':'') + '/proposal/part1/' + Utils.encodeItem({proposalId: row.id, readOnly: true})}>
                                                                                {prop.lang === 'en' ? 'Part 1 General':'ส่วนที่ 1 ข้อมูลทั่วไป'}
                                                                            </NavLink>
                                                                            <NavLink className="btn btn-xs btn-gray mt-1" to={(prop.lang === 'en' ? '/en':'') + '/proposal/part2/' + Utils.encodeItem({proposalId: row.id, readOnly: true})}>
                                                                                {prop.lang === 'en' ? 'Part 2 Research project information':'ส่วนที่ 2 ข้อมูลโครงการวิจัย'}
                                                                            </NavLink>
                                                                            <NavLink className="btn btn-xs btn-gray mt-1" to={(prop.lang === 'en' ? '/en':'') + '/proposal/part3/' + Utils.encodeItem({proposalId: row.id, readOnly: true})}>
                                                                                {prop.lang === 'en' ? 'Part 3 Plan':'ส่วนที่ 3 แผนงาน'}
                                                                            </NavLink>
                                                                            <NavLink className="btn btn-xs btn-gray mt-1" to={(prop.lang === 'en' ? '/en':'') + '/proposal/part4/' + Utils.encodeItem({proposalId: row.id, readOnly: true})}>
                                                                                {prop.lang === 'en' ? 'Part 4 Business Operator Information (Optional)':'ส่วนที่ 4 ข้อมูลผู้ประกอบการ (ถ้ามี)'}
                                                                            </NavLink>
                                                                            <NavLink className="btn btn-xs btn-gray mt-1" to={(prop.lang === 'en' ? '/en':'') + '/proposal/part5/' + Utils.encodeItem({proposalId: row.id, readOnly: true})}>
                                                                                {prop.lang === 'en' ? 'Part 5 Output/Result/Impact':'ส่วนที่ 5 ผลผลิต/ผลลัพธ์/ผลกระทบ'}
                                                                            </NavLink>
                                                                        </td>
                                                                    </tr> : ''
                                                            }
                                                        </>
                                                    )
                                                }) : <tr key={-1}><td colSpan={4} className="text-center">{prop.lang === 'en' ? 'No participating projects':'ยังไม่มีโครงการที่เข้ารว่ม'}</td></tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 